import React from 'react';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { I_FilterItemList } from '../interface';

import AirlineBlock from './AirlineBlock';
import TransferCountBlock from './TransferCountBlock';
import TimeRangeBlock from './TimeRangeBlock';
import SeqAirportBlock from './SeqAirportBlock';
import TransferPointBlock from './TransferPointBlock';
import CabinBlock from './CabinBlock';
import GiftBlock from './GiftBlock';
import PromotionEntrance from '@features/PromotionEntrance'

interface I_FilterContentsProps {
    showFilterItems: I_FilterItemList;
    mobileProps?: {
        tempMFilter: I_FilterItemList | null;
        setTempMFilter: Function;
    };
}

const FilterContents = (props: I_FilterContentsProps) => {
    const moduleName = 'filters';
    const { showFilterItems, mobileProps } = props;
    const showMax = 5; //最多要顯示數量

    const hasItem = (type: string): boolean => {
        if (type === 'Gifts') return showFilterItems[type].length > 1;
        return showFilterItems[type].length > 0;
    };

    return (
        <div className={cN(moduleName, styles[moduleName])}>
            <ul className={styles.filterBlocks}>

                <li className={cN(styles.filterBlock, styles.mobileHide)}>
                    <PromotionEntrance className='imageWrap_pc' />
                </li>

                {hasItem('transfer') && (
                    <TransferCountBlock
                        title="轉機次數"
                        showMax={showMax}
                        cols={2}
                        transferCountOptions={showFilterItems.transfer}
                        mobileProps={mobileProps}
                    />
                )}

                {hasItem('airport') && (
                    <AirlineBlock
                        title="航空公司"
                        showMax={showMax}
                        cols={1}
                        airlineOptions={showFilterItems.airport}
                        mobileProps={mobileProps}
                    />
                )}

                <TimeRangeBlock
                    title="出發時間"
                    cols={2}
                    departureTimeRanges={showFilterItems.departureTimesRanges}
                    crossDayOptions={showFilterItems.crossday}
                    mobileProps={mobileProps}
                />

                {hasItem('seqAirport') && (
                    <SeqAirportBlock
                        title="機場"
                        cols={2}
                        seqAirports={showFilterItems.seqAirport}
                        mobileProps={mobileProps}
                    />
                )}

                {hasItem('transferPoint') && (
                    <TransferPointBlock
                        title="轉機點"
                        showMax={showMax}
                        cols={1}
                        transferOptions={showFilterItems.transferPoint}
                        mobileProps={mobileProps}
                    />
                )}

                {hasItem('Cabin') && (
                    <CabinBlock
                        title="艙等"
                        cols={2}
                        cabinOptions={showFilterItems.Cabin}
                        mobileProps={mobileProps}
                    />
                )}

                {hasItem('Gifts') && (
                    <GiftBlock
                        title="禮品"
                        cols={2}
                        giftOptions={showFilterItems.Gifts}
                        mobileProps={mobileProps}
                    />
                )}
            </ul>
        </div>
    );
};

export default FilterContents;
